export const environment = {
  production: false,
  base_url: 'https://alltel-api.allteltest.com/api',
  my_alltel_url: 'https://my.allteltest.com'
};
